export function toggleSelectionInOdds(oddUuids: string[], selection: { uuid: string }): string[] {
    if (oddUuids.includes(selection.uuid)) {
        return oddUuids.filter((uuid) => uuid !== selection.uuid);
    }

    return [...oddUuids, selection.uuid];
}
